import { AnyAction } from 'redux';
import { CONTRACT_NEW } from 'redux/actions/contract';
import {
 	CONTRACT_FINALIZED_BY_EMAIL
} from 'redux/actions/contractFinishByEmail';
import {
	ContractFinishState,
	ContractFinishStatus,
} from '../../types/redux';

const initialState: ContractFinishState = {
	status: ContractFinishStatus.WAITING,
};

export function contractFinishReducer(
	state: ContractFinishState = initialState,
	action: AnyAction
): ContractFinishState {
	switch (action.type) {
		case CONTRACT_NEW:// case CONTRACT_FINALIZED_BY_EMAIL: return {		...state, 		status: ContractSignatureStatus.SIGN_LATER, 	};
		case CONTRACT_FINALIZED_BY_EMAIL:
			return {
				...state,
				status: ContractFinishStatus.FINISHED
			};

		default:
			return state;
	}
}
